var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "invention-apply" }, [
    _vm.isFinish
      ? _c("div", { staticClass: "deadline" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("InventionApply.Invention.deadline")) + " "
          ),
        ])
      : _c("div", { staticClass: "web-content" }, [
          _c("div", { staticClass: "process-structure" }, [
            _c(
              "div",
              { staticClass: "apply-process-body" },
              [
                _c("div", { staticClass: "process-page-title-row" }, [
                  _c("div", { staticClass: "process-page-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("InventionApply.Invention.title")) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "v-stepper",
                  {
                    staticClass: "stepper",
                    attrs: { "alt-labels": "", value: _vm.nowStep },
                  },
                  [
                    _c(
                      "v-stepper-header",
                      [
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(0),
                              complete: _vm.nowStep > 0,
                              step: "0",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[0]")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-divider"),
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(1),
                              complete: _vm.nowStep > 1,
                              step: "1",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[1]")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-divider"),
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(2),
                              complete: _vm.nowStep > 2,
                              step: "2",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[2]")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-divider"),
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(3),
                              complete: _vm.nowStep > 3,
                              step: "3",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[3]")
                                )
                            ),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[4]")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-divider"),
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(4),
                              complete: _vm.nowStep > 4,
                              step: "4",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[5]")
                                )
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm.$t("InventionApply.Invention.stepper[6]")
                              ) + " "
                            ),
                          ]
                        ),
                        _c("v-divider"),
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              color: _vm.stepColor(5),
                              complete: _vm.nowStep > 5,
                              step: "5",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("InventionApply.Invention.stepper[7]")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("router-view"),
              ],
              1
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }